(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var nav = document.getElementById('ps-nav');
    var toggle = document.getElementById('ps-nav-toggle');
    var links = document.getElementById('ps-nav-links');
    if (!nav) return;

    var hero = document.querySelector('.ps-hero');

    function onScroll() {
      var past = hero ? window.scrollY > hero.offsetHeight - 90 : window.scrollY > 40;
      nav.classList.toggle('scrolled', window.scrollY > 40);
      nav.classList.toggle('hero-mode', !past);
    }
    window.addEventListener('scroll', onScroll);
    onScroll();

    if (toggle && links) {
      toggle.addEventListener('click', function () {
        var isOpen = links.classList.toggle('open');
        toggle.setAttribute('aria-expanded', isOpen);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
